export enum AdminNavigationItem {
    User = 'Benutzer',
    Trainings = 'Trainings',
    Performance = 'Performance',
    Token = 'Token',
    Credits = 'Credits',
    Settings = 'Settings',
}
